/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_your_membership_has_expired: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Your Membership Has Expired`,
    es: `Tu membresía ha expirado`,
  };
  return phrases[locale] || phrases.en || `Your Membership Has Expired`;
};
